import { Box, Button, Typography } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom-v5-compat'

import { useAcceptInvitation } from '@/app/module/auth/hooks/use-accept-invitation'

import { Container, Content } from './common'
import { InvitationResponse } from './types'

type Props = {
  invitationResponse: InvitationResponse
  invitationToken: string
}

const LoggedInSame: React.FC<Props> = ({ invitationResponse, invitationToken }) => {
  const navigate = useNavigate()

  const [acceptInvitation, { isLoading }] = useAcceptInvitation()

  const handleAccept = async () => {
    const result = await acceptInvitation({
      invitationToken,
    })

    if (!result) {
      return
    }

    navigate('/dashboard')
  }

  return (
    <Container>
      <Content>
        <Typography className="invitation-message-text" variant="h5" textAlign="center">
          You have been invited to the organization {invitationResponse.orgName} ({invitationResponse.orgId}).
          <br />
          If you want to join that organization, click accept below.
        </Typography>
        <Box pt={2} textAlign="center">
          <Button color="primary" loading={isLoading} variant="contained" onClick={handleAccept} disabled={isLoading}>
            Accept
          </Button>
        </Box>
      </Content>
    </Container>
  )
}

export default LoggedInSame
